import { useEffect, useRef } from 'react';

export const AI_ONBOARDING_INACTIVITY_TIMEOUT_MS = 30000;

interface IUseAiInactivityFallback {
  activitySequence: number;
  isPaused: boolean;
  isWaitingForUserResponse: boolean;
  latestAgentResponseId: string | null;
  onTimeout: () => void;
}

const useAiInactivityFallback = ({
  activitySequence,
  isPaused,
  isWaitingForUserResponse,
  latestAgentResponseId,
  onTimeout,
}: IUseAiInactivityFallback) => {
  const hasTimedOutRef = useRef(false);
  const pausedResponseIdRef = useRef<string | null>(null);

  useEffect(() => {
    let timeoutId: number | null = null;

    if (isPaused) {
      pausedResponseIdRef.current = latestAgentResponseId;
    } else if (
      !isWaitingForUserResponse
      || !latestAgentResponseId
      || pausedResponseIdRef.current === latestAgentResponseId
    ) {
      hasTimedOutRef.current = false;
    } else {
      timeoutId = window.setTimeout(() => {
        if (hasTimedOutRef.current) {
          return;
        }

        hasTimedOutRef.current = true;
        onTimeout();
      }, AI_ONBOARDING_INACTIVITY_TIMEOUT_MS);
    }

    return () => {
      if (timeoutId !== null) {
        window.clearTimeout(timeoutId);
      }
    };
  }, [
    activitySequence,
    isPaused,
    isWaitingForUserResponse,
    latestAgentResponseId,
    onTimeout,
  ]);
};

export default useAiInactivityFallback;
